// * Bootstrap libraries
import './_bootstrap';
import './components/modals';

// * Any other global site-wide JavaScript should be placed below.
